import { ScheduleRouteRepetitionType } from '~globals/types/enums';

import { pluralize } from '../../commons';

export const isRouteScheduleRepetionTypeDaily = (
  type: ScheduleRouteRepetitionType,
): boolean => type === ScheduleRouteRepetitionType.Daily;

export const isRouteScheduleRepetionTypeWeekly = (
  type: ScheduleRouteRepetitionType,
): boolean => type === ScheduleRouteRepetitionType.Weekly;

export const isRouteScheduleRepetionTypeMonthly = (
  type: ScheduleRouteRepetitionType,
): boolean => type === ScheduleRouteRepetitionType.Monthly;

export const getRouteScheduleRepitionTypeDescriptionPrefix = (
  type: ScheduleRouteRepetitionType,
): string => {
  let prefix = 'Semanal';

  if (isRouteScheduleRepetionTypeDaily(type)) prefix = 'Diario';

  if (isRouteScheduleRepetionTypeMonthly(type)) prefix = 'Mensual';

  return prefix;
};

export const getRouteScheduleRepitionDescriptionUnit = (
  type: ScheduleRouteRepetitionType,
  repitionIntervalCount: number,
): string => {
  if (isRouteScheduleRepetionTypeDaily(type)) {
    return pluralize({
      singular: 'Dia',
      count: repitionIntervalCount,
      includeCount: false,
    });
  }

  if (isRouteScheduleRepetionTypeMonthly(type)) {
    return pluralize({
      singular: 'Mes',
      plural: 'Meses',
      count: repitionIntervalCount,
      includeCount: false,
    });
  }

  return pluralize({
    singular: 'Semana',
    count: repitionIntervalCount,
    includeCount: false,
  });
};
